<template>
  <div>
    <a-select
      :value="value"
      :show-search="showSearch"
      :allow-clear="allowClear"
      :mode="mode || undefined"
      :placeholder="placeholder"
      :disabled="disabled"
      option-filter-prop="title"
      @change="onChange"
    >
      <a-select-option
        v-for="item in options"
        :key="item.valCode"
        :value="item.valCode"
        :title="item.valName"
        :disabled="disableArray.includes(item.valCode)"
      >
        {{ item.valName }}
      </a-select-option>
    </a-select>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, PropType, ref } from "vue";
import { DictValRecord } from "@/views/system/dict/dict.interface";
import { DictService } from "@/views/system/dict/dict.service";

type IValue = string[] | string | undefined;
type ISelectMode = undefined | "" | "multiple" | "tags" | "combobox";

/**
 * 全局组件: 字段选择器
 *
 * 使用方式:
 * <verification-select v-model="formRef.dictCode" code="sex"></verification-select>
 */
export default defineComponent({
  isGlobal: true,
  name: "Verification",
  props: {
    code: {
      type: String,
      required: true,
    },
    value: {
      type: [Array, String] as PropType<IValue>,
      default: undefined,
    },
    mode: {
      type: String as PropType<ISelectMode>,
      default: "",
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    showSearch: {
      type: Boolean,
      default: true,
    },
    allowClear: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disableArray: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["update:value", "change"],
  setup(props, { emit }) {
    const options = ref<DictValRecord[]>([]);

    const onChange = (code) => {
      emit("update:value", code);
      emit("change", code);
    };

    onMounted(async () => {
      if (!props.code) {
        return;
      }
      options.value = await DictService.fetchOptionsByDictCode(props.code);
    });

    return {
      options,
      onChange,
    };
  },
});
</script>
